import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@WhiteCap/Store/Data/CustomApplicationState/CustomDataReducer";

(reducers as any).WhiteCap = customDataReducer;

// (reducers as any).t_components = componentsReducer;

type CustomReducers = {
    WhiteCap: typeof customDataReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;
